import { Component, OnInit, Injector } from '@angular/core';
import { TenantDashboardServiceProxy, PaymentGatewayServiceProxy} from '@shared/service-proxies/service-proxies';
import { LazyLoadEvent } from 'primeng/api';
import * as moment from 'moment';
import { DashboardChartBase } from '../dashboard-chart-base';
import { WidgetComponentBase } from '../widget-component-base';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { AppState } from '@app/store/TransactionDashboard/transactionDashboard.model';


class TransactionStats extends DashboardChartBase {

  totalTransactions = 0; totalTransactionsCounter = 0;
  totalAmount = 0; totalAmountCounter = 0;
  totalNetCharge = 0; totalNetChargeCounter = 0;

  init(totalTransactions, totalAmount, totalNetCharge) {
    this.totalTransactions = totalTransactions;
    this.totalAmount = totalAmount;
    this.totalNetCharge = totalNetCharge;
    this.hideLoading();
  }
}

@Component({
  selector: 'app-widget-transaction-dashboard',
  templateUrl: './widget-transaction-dashboard.component.html',
  styleUrls: ['./widget-transaction-dashboard.component.css']
})

export class WidgetTransactionDashboardComponent extends WidgetComponentBase implements OnInit {

 
  transactionDataLength: number;
  transactionStats: TransactionStats;
  today:any = moment.utc();
  lastMonth: any = this.today.clone().subtract(1, 'month');
  startDate = this.lastMonth.clone().startOf('month');
  endDate = this.lastMonth.clone().endOf('month');
  selectedDateRange: moment.Moment[] = [moment().add(-1, 'days'), moment().add(-1, 'day'), moment().subtract(7, 'days'), this.startDate, this.endDate];
  currencyCode = "MYR";
  resTotalTransactions;
  resTotalAmount;
  resTotalNetCharge;

  counter = 0;
  currencyCodeList:any;

  filterDays = [{
    name: 'Yesterday',
    value: 'yesterday'
  }, {
    name: 'Last 7 days',
    value: 'lastSevenDays'
  }, {
    name: 'Last month',
    value: 'lastMonth'
  }]

  selectedDate: string = this.selectedDateRange[0].format('L');

  yesterdayData$: Observable<any>;
  last7dayData$: Observable<any>;
  lastMonthData$: Observable<any>;
  isYesterday: boolean = true;
  isLastMonth: boolean = false;
  //dailySalesLineChart: DailySalesLineChart;

  constructor(injector: Injector,
    private _paymentService: PaymentGatewayServiceProxy,
    private store: Store<{ transactionDashboardState: AppState }>) {
    super(injector);
    this.transactionStats = new TransactionStats();
    this.yesterdayData$ = store.select((state)=> state?.transactionDashboardState.yesterdayT);
    this.last7dayData$ = store.select((state)=> state?.transactionDashboardState.last7dayT);
    this.lastMonthData$ = store.select((state)=> state?.transactionDashboardState.lastMonthT);
  }

  ngOnInit() {
    this.yesterdayData$.subscribe((res) => {
      if (res && res.length > 0) {
        const dailyList = res[0]?.dailyTransactionSummarizedList || [];
        this.currencyCodeList = [
          ...new Set(dailyList.map(item => item.currencyCode))
        ].map(currency => ({ name: currency, value: currency }));
        this.currencyCode = this.currencyCodeList[0].value
      }
    });

    this.fetchData(this.isYesterday, this.isLastMonth, this.currencyCode);

  }

  fetchData(isYesterdayData: boolean, isLastMonthData: boolean, currencyCode:string) {
    this.resTotalTransactions = 0; 
    this.resTotalAmount = 0;
    this.resTotalNetCharge = 0;
  
    const source$ = isYesterdayData ? this.yesterdayData$ : (isLastMonthData ? this.lastMonthData$ : this.last7dayData$);
    const selectedDate = isYesterdayData
      ? this.selectedDateRange[0].format('L')
      : ( isLastMonthData ? `${this.selectedDateRange[3].format('L')} - ${this.selectedDateRange[4].format('L')}` : `${this.selectedDateRange[2].format('L')} - ${this.selectedDateRange[0].format('L')}`);
    
    source$.subscribe((res) => {
      if (res && res.length > 0) {
        const dailyList = res[0]?.dailyTransactionSummarizedList || [];
        this.transactionDataLength = dailyList.length;
        this.currencyCode = currencyCode
        this.currencyCodeList = [
          ...new Set(dailyList.map(item => item.currencyCode))
        ].map(currency => ({ name: currency, value: currency }));
  

        dailyList.forEach(item => {
          if (item.currencyCode === currencyCode) {
            this.resTotalTransactions += item.totalTransaction;
            this.resTotalAmount += item.totalAmount;
        
            const chargeValue = this.appSession.tenantId
              ? item.totalCharge 
              : item.netChargeValue; 
        
            this.resTotalNetCharge += parseFloat(chargeValue.toFixed(2));
          }
        });
  
        this.transactionStats.init(this.resTotalTransactions, this.resTotalAmount, this.resTotalNetCharge);
      } else {
        this.transactionDataLength = 0;
      }
    });
  
    this.selectedDate = selectedDate;
  }

  filterDaysChangeHandler(event: any){
    // the dropdown uses optionValue="value", so event.value is the plain string
    const selected = (event.value !== null && typeof event.value === 'object') ? event.value.value : event.value;
    if(selected === 'yesterday'){
      this.isYesterday = true;
      this.isLastMonth = false;
    }else if(selected === 'lastMonth'){
      this.isYesterday = false;
      this.isLastMonth = true;
    }else{
      this.isYesterday = false;
      this.isLastMonth = false;
    }
    this.fetchData(this.isYesterday, this.isLastMonth, this.currencyCode);
  }

  filterCurrencyChangeHandler(event: any){
    this.currencyCode = (event.value !== null && typeof event.value === 'object') ? event.value.value : event.value;
    this.fetchData(this.isYesterday, this.isLastMonth, this.currencyCode);
  }
}